function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcaeTShihan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M50,14.74c-19.48,0-35.26,15.79-35.26,35.26s15.79,35.26,35.26,35.26,35.26-15.79,35.26-35.26S69.47,14.74,50,14.74ZM50,77.67c-15.28,0-27.67-12.39-27.67-27.67s12.39-27.67,27.67-27.67,27.67,12.39,27.67,27.67-12.39,27.67-27.67,27.67Z",
    style: {
      fill: "#000",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.78,79.61c0,2.09-1.69,3.78-3.78,3.78s-3.77-1.69-3.77-3.78V20.38c0-2.09,1.69-3.77,3.77-3.77s3.78,1.69,3.78,3.77v59.23Z",
    style: {
      fill: "#000",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.13,76.54c.71,1.96-.3,4.13-2.26,4.84s-4.13-.3-4.84-2.26l-18.26-45.66c-.71-1.96.3-4.12,2.26-4.84s4.13.29,4.84,2.25l18.26,45.66Z",
    style: {
      fill: "#000",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.87,76.54c-.71,1.96.3,4.13,2.26,4.84s4.13-.3,4.84-2.26l18.26-45.66c.71-1.96-.3-4.12-2.26-4.84s-4.13.29-4.84,2.25l-18.26,45.66Z",
    style: {
      fill: "#000",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcaeTShihan);
export default __webpack_public_path__ + "static/media/acae_t_shihan.819a0e97.svg";
export { ForwardRef as ReactComponent };